import React from "react";
import { Modal } from "reactstrap";
import { ModalBody } from "reactstrap";
import crossIcon from "../../assets/images/cross.svg";
import styles from "./deleteConfirmationModal.module.scss";
import Text from "components/Text";
import { withTranslation } from "react-i18next";

const DeleteConfirmationModal = ({
  t,
  confirmDelete,
  closeDeleteModal,
  confirmDeleteMessage,
  deleteMessage,
  title,
  btnText,
  isLoading,
}) => {
  const handleApply = async () => {
    if (isLoading) return;
    await confirmDeleteMessage();
  };

  return (
    <Modal
      isOpen={confirmDelete}
      toggle={closeDeleteModal}
      className="modal-dialog-centered modal-lg"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={closeDeleteModal}>
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody>
        <div className={styles["delete_task_modal"]}>
          <Text size="25px" weight="500" color="#111B45">
            {title}
          </Text>

          <Text size="16px" weight="300" color="#535B5F" margintop="11px">
            {deleteMessage}
          </Text>

          <div
            className={styles["delete_task_btn_wrapper"] + " btn-box d-md-flex"}
          >
            <button
              className={
                styles["delete_task_btn"] +
                " button button-round button-shadow mr-md-4 mb-3 w-sm-100"
              }
              title="save"
              onClick={handleApply}
              disabled={isLoading}
            >
              {btnText}
            </button>
            <button
              className={
                styles["delete_task_btn"] +
                " mb-md-3 button button-round button-border btn-mobile-link button-dark"
              }
              title="cancel"
              onClick={closeDeleteModal}
            >
              {t("notes.cancel")}
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
export default withTranslation()(DeleteConfirmationModal);
